export const defaultTriggerEmailSubject = 'Alert **TRIGGERED** - [ALERT_NAME]';
export const defaultTriggerEmailBody = 'Device: \t\t [DEVICE_NAME] ([MAC_ADDRESS])\n'
+ 'Sensor: \t\t [SENSOR_TYPE] : [SENSOR_NAME]\n'
+ 'Threshold: \t [THRESHOLD]\n\n'
+ '\t\tLatest Reading:\n'
+ '[NOTIFICATION_TIME]\n'
+ '[CURRENT_VALUE]\n\n';
export const defaultClearEmailSubject = 'Alert **CLEARED** - [ALERT_NAME]\n';
export const defaultClearEmailBody = 'Device: \t\t [DEVICE_NAME] ([MAC_ADDRESS])\n'
+ 'Sensor: \t\t [SENSOR_TYPE] : [SENSOR_NAME]\n'
+ 'Threshold: \t [THRESHOLD]\n'
+ 'Triggered: \t [TRIGGER_TIME]\n'
+ 'Duration: \t [ALERT_ELAPSED]\n\n'
+ '\t\tLatest Reading:\n'
+ '[NOTIFICATION_TIME]\n'
+ '[CURRENT_VALUE]\n\n';
export const defaultTriggerTextMessage = '*ALERT* - [ALERT_NAME]. \tTRIGGERED AT: [TRIGGER_TIME] \tCURRENT VALUE: [CURRENT_VALUE]';
export const defaultClearTextMessage = '*OK* - [ALERT_NAME]. \tCLEARED AT: [CLEAR_TIME] \tCURRENT VALUE: [CURRENT_VALUE]';

export const EMAIL_TEMPLATE_TYPE = 'email';
export const SMS_TEMPLATE_TYPE = 'sms';
export const TRIGGERED_EMAIL_SUBJECT = 'emailTemplateTriggeredSubject';
export const CLEARED_EMAIL_SUBJECT = 'emailTemplateClearedSubject';
export const TRIGGERED_EMAIL_BODY = 'emailTemplateTriggeredBody';
export const CLEARED_EMAIL_BODY = 'emailTemplateClearedBody';
export const TRIGGERED_SMS_BODY = 'smsTemplateTriggeredBody';
export const CLEARED_SMS_BODY = 'smsTemplateClearedBody';

export const keywordList = {
  '[ALERT_NAME]': {
    description: 'Name of the alert.',
  },
  '[THRESHOLD]': {
    description: 'Value the sensor reading must pass to trigger the alert.',
  },
  '[CURRENT_VALUE]': {
    description: 'Current value of the sensor being monitored.',
  },
  '[NOTIFICATION_TIME]': {
    description: 'Date and time that the alert notification was sent.',
  },
  '[TRIGGER_TIME]': {
    description: 'Date and time that the alert occurred.',
  },
  '[CLEAR_TIME]': {
    description: 'Date and time that the alert cleared.',
  },
  '[ALERT_ELAPSED]': {
    description: 'Amount of time that the alert has been active.',
  },
  '[DEVICE_NAME]': {
    description: 'Name of device being monitored.',
  },
  '[DEVICE_IP]': {
    description: 'IP address of the device being monitored.',
  },
  '[DEVICE_PORT]': {
    description: 'Web port used by the device being monitored.',
  },
  '[MAC_ADDRESS]': {
    description: 'The MAC address of the device being monitored.',
  },
  '[COMPONENT_NAME]': {
    description: 'Additional context for MAX devices. (Will be blank for PRO devices.)',
  },
  '[SENSOR_NAME]': {
    description: 'Name of the sensor being monitored.',
  },
  '[SENSOR_TYPE]': {
    description: 'Type of sensor being monitored.',
  },
  '[ADDITIONAL_SENSORS]': {
    description: 'Details and current value of any Additional Sensor(s) linked to alert.',
  },
};
